import { render, staticRenderFns } from "./update-research-group-detail.html?vue&type=template&id=6990753e&scoped=true&"
import script from "./update-research-group-detail.js?vue&type=script&lang=js&"
export * from "./update-research-group-detail.js?vue&type=script&lang=js&"
import style0 from "./update-research-group-detail.scss?vue&type=style&index=0&id=6990753e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6990753e",
  null
  
)

export default component.exports